import axios from '@/api/config';

const question = {
  getQuestionById(data) {
    return axios.get(`${process.env.BASE_URL}/question/getQuestion/` + data, {});
  },
  getQuestionByExercise(data) {
    return axios.get(`${process.env.BASE_URL}/question/getQuestionByExercise`, {
      params: data
    });
  },
  getQuestion(data) {
    return axios.get(`${process.env.BASE_URL}/question/getQuestion`, {
      params: data
    });
  },
  getQuestionList(data) {
    return axios.get(`${process.env.BASE_URL}/question/getQuestionList`, {
      params: data
    });
  },
  getQuestionTree(data) {
    return axios.get(`${process.env.BASE_URL}/question/getQuestionTree`, {
      params: data
    });
  },
  questionTypeList(data) {
    return axios.get(`${process.env.BASE_URL}/questionType/questionTypeList`, {
      params: data
    });
  },
  questionTypeNormalList(data) {
    return axios.get(`${process.env.BASE_URL}/questionType/questionTypeNormalList`, {
      params: data
    });
  },
  questionTypeByExam(data) {
    return axios.get(`${process.env.BASE_URL}/questionType/questionTypeByExam`, {
      params: data
    });
  },
  pageListSelectByExam(data) {
    return axios.post(`${process.env.BASE_URL}/question/pageListSelectByExam`, data);
  },

  questionTypeBigList(data) {
    return axios.get(`${process.env.BASE_URL}/questionType/questionTypeBigList`, {
      params: data
    });
  },
  questionListByExam(data) {
    return axios.get(`${process.env.BASE_URL}/question/questionListByExam`, {
      params: data
    });
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/question/pageList`, data);
  },
  pageListByChapter(data) {
    return axios.post(`${process.env.BASE_URL}/question/pageListByChapter`, data);
  },
  pageListByExam(data) {
    return axios.post(`${process.env.BASE_URL}/question/pageListByExam`, data);
  },
  addQuestion(data) {
    return axios.post(`${process.env.BASE_URL}/question/addQuestion`, data);
  },
  addNormalQuestion(data) {
    return axios.post(`${process.env.BASE_URL}/question/addNormalQuestion`, data);
  },
  updateNormalQuestion(data) {
    return axios.post(`${process.env.BASE_URL}/question/updateNormalQuestion`, data);
  },
  addBigQuestion(data) {
    return axios.post(`${process.env.BASE_URL}/question/addBigQuestion`, data);
  },
  updateBigQuestion(data) {
    return axios.post(`${process.env.BASE_URL}/question/updateBigQuestion`, data);
  },
  addSmallQuestion(data) {
    return axios.post(`${process.env.BASE_URL}/question/addSmallQuestion`, data);
  },
  updateSmallQuestion(data) {
    return axios.post(`${process.env.BASE_URL}/question/updateSmallQuestion`, data);
  },
  deleteQuestion(data) {
    return axios.post(`${process.env.BASE_URL}/question/deleteQuestion`, data);
  },
  updateQuestion(data) {
    return axios.put(`${process.env.BASE_URL}/question/updateQuestion`, data);
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/question/exportExcel`, {
      params: data
    });
  },
  getTitleById(data) {
    return axios.get(`${process.env.BASE_URL}/question/getTitleById`, {
      params: data
    });
  },
  getInfoById(data) {
    return axios.get(`${process.env.BASE_URL}/question/getInfoById`, {
      params: data
    });
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/question/importData`, data);
  },
  deleteChapterQuestion(data) {
    return axios.post(`${process.env.BASE_URL}/question/deleteChapterQuestion`, data);
  },
  deleteExamQuestion(data) {
    return axios.post(`${process.env.BASE_URL}/question/deleteExamQuestion`, data);
  },
  getQuestionAnalysisByExamId(data) {
    return axios.post(`${process.env.BASE_URL}/examResult/getQuestionAnalysisByExamId`, data);
  },
  // 获取考试系统题目解析列表
  getExamQuizData(data) {
    return axios.post(`${process.env.BASE_URL}/examinationStudent/topicAnalysis`, data);
  },
  getExamQuizTitleData(data) {
    return axios.post(`${process.env.BASE_URL}/examinationStudent/getNumberExam`, data);
  },
  getQuestionByExam(data) {
    return axios.get(`${process.env.BASE_URL}/question/getQuestionByExam`, {
      params: data
    });
  },
  cleanQuestionByExamCache(data) {
    return axios.get(`${process.env.BASE_URL}/question/cleanQuestionByExamCache`, {
      params: data
    });
  },
  simulateSubmitExerciseForModelExam(data) {
    return axios.post(`${process.env.BASE_URL}/question/simulateSubmitExerciseForModelExam`, data);
  },
  simulateGetQuestionByModelExam(data) {
    return axios.get(`${process.env.BASE_URL}/question/simulateGetQuestionByModelExam`, {
      params: data
    });
  },
  simulateGetQuestionByExercise(data) {
    return axios.get(`${process.env.BASE_URL}/question/simulateGetQuestionByExercise`, {
      params: data
    });
  },
  getExerciseResultById(data) {
    return axios.get(`${process.env.BASE_URL}/question/getExerciseResultById`, {
      params: data
    });
  },
  getSubjectiveQuestionForModelExam(data) {
    return axios.get(`${process.env.BASE_URL}/question/getSubjectiveQuestionForModelExam`, {
      params: data
    });
  },
  submitSubjectiveQuestionForModelExam(data) {
    return axios.post(`${process.env.BASE_URL}/question/submitSubjectiveQuestionForModelExam`, data);
  },
}

export default question;



// WEBPACK FOOTER //
// ./src/api/question.js